import React from "react";
import PlayArrowTwoToneIcon from "@mui/icons-material/PlayArrowTwoTone";
import { Button, Tooltip } from "@mui/material";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function CustomizedDialogs(props) {
  let { endDate, endTime, startDate, dependson, labType } = props;

  function DateTime2(endDate) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endDate1 = new Date(endDate).toLocaleString("en-GB", {
      timeZone: timezone,
    });
    const endDate2 = endDate1.split(",");
    const endDatef = endDate2[0].replace(/\//g, "-");
    const endDate3 = endDatef.replace(/\//g, "-");
    return endDate3;
  }

  function timeDiff(endDate, endTime, startDate, dependson) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endTime1 = new Date(endDate + "T" + endTime + ":00.000Z").toLocaleString("en-GB", { timeZone: `${timezone}` });
    const endTime2 = endTime1.split(",");
    const endTime3 = endTime2[1].substring(0, 6);
    const currentTime = new Date().toLocaleString('en-GB', { timeZone: `${timezone}` });
    const currentTime1 = currentTime.split(",");
    const formattedTime = currentTime1[1].substring(0, 6);
    const endTimeMoment = moment(endTime3, 'HH:mm');
    const formattedTimeMoment = moment(formattedTime, 'HH:mm');
    
    let disableButton = false;
    const diffInMinutes = endTimeMoment.diff(formattedTimeMoment, 'minutes');

    const labEndDate = moment(endDate).format("DD-MM-YYYY");
    var currentDate = new Date().toISOString().substring(0, 10);

    if (dependson === "always") {
      if (DateTime2(currentDate) == labEndDate) {
        if (diffInMinutes > 0 && diffInMinutes <= `${process.env.REACT_APP_DIFFENDTIME}`) {
          disable = true;
        }
        else if (diffInMinutes <= 0){
          disableButton = true;
        }
        else {
          disableButton = false;
        }
      }
      else {
        if (new Date(currentDate) <= new Date(endDate)) {
          disableButton = false;
        }
        else {
          disableButton = true;
        }
      }
    }
    else {
      disableButton = diffInMinutes <= `${process.env.REACT_APP_DIFFENDTIME}` && diffInMinutes >= 0;
    }
    // console.log("difference_minutes", `${process.env.REACT_APP_DIFFENDTIME}`)
    // console.log("diffInMinutes", diffInMinutes);
    // console.log("disableButton button status", disableButton);
    return disableButton;
  }


  const [open, setOpen] = React.useState(false);
  const [popupopen, setPopUpOpen] = React.useState(false);
  const [opentitle, setOpentitle] = React.useState();
  const [popupopentitle, setPopupOpentitle] = React.useState("Are you sure you want to start a lab?.");

  const handleClose = () => {
    setOpen(false);
    setPopUpOpen(false);
  };

  const handlePopUpClose = () => {
    setPopUpOpen(false);
  };

  const handleOpen = () => {
    setPopUpOpen(true);
  };

  const handleSubmitClick = (e) => {
    e.preventDefault();
    // window.location.reload();
    let api_call = ""
    const InstanceID = localStorage.getItem("InstanceID");
    if (labType === "pc") {
      api_call = `${process.env.REACT_APP_API_URL}/api/startpreconfiguredlab/${InstanceID}`
    }
    else if (labType === "custom") {
      api_call = `${process.env.REACT_APP_API_URL}/api/startlab/${InstanceID}`
    }
    else if (labType === "hvm") {
      api_call = `${process.env.REACT_APP_API_URL}/api/starthvmclab/${InstanceID}`
    }
    else if (labType === "svm") {
      api_call = `${process.env.REACT_APP_API_URL}/api/startsvmlab/${InstanceID}`
    }
    else if (labType === "wise") {
      api_call = `${process.env.REACT_APP_API_URL}/api/startwiselab/${InstanceID}`
    }
    
    fetch(api_call, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          if (data === "Success") {
            setOpen(false);
            window.location.reload();
          }
          else {
            setOpen(true);
            setOpentitle(data);
          }
        } else {
          if (data.name) {
            setOpen(false);
            setState({ errorMessage: data.name[0] });
          }
        }
      })
      .catch((error) => {
        setOpen(false);
        window.location.reload();
      });
  };



  return (
    <div>
      <Dialog
          open={popupopen}
          onClose={handlePopUpClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
          {popupopentitle} {" "}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description"></DialogContentText>
          </DialogContent>
          <DialogActions>
          <Button onClick={handlePopUpClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleSubmitClick} color="primary">
              Ok
            </Button>
          </DialogActions>
      </Dialog>
      <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
          {opentitle} {" "}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description"></DialogContentText>
          </DialogContent>
          <DialogActions>
          <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      <Tooltip title="Start" arrow>
        <Button
          sx={{ 
            mx: 1,
            height: { xs: "26px", sm: "30px" },
            width: { xs: "26px", sm: "30px" },
            minWidth: 'auto',
            marginBottom: { xs: "3px", sm: "5px" },
            marginTop: { xs: "-18px", sm: "-20px" },
            borderRadius: '50px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
            p: 0,
          }}
          variant="outlined"
          color="primary"
          onClick={handleOpen}
          disabled={ timeDiff(endDate, endTime, startDate, dependson, labType) }
          aria-label="Start"
        >
          <PlayArrowTwoToneIcon sx={{ fontSize: { xs: '1rem', sm: '1.1rem' } }} />
        </Button>
      </Tooltip>
    </div>
  );
}
